import React, { useRef, useEffect } from 'react';
import coOwnSpaceLogo from '../../Assests/images/logo/co-own-space-black.png';
import AnimatedContent from "../Common/AnimatedContent";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Appraisal = () => {
    const ourMissionRef = useRef(null);

    useEffect(() => {
        if (window.location.hash === '#ourmission') {
            ourMissionRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    const textVariants = {
        hidden: { opacity: 0, x: -10 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
        }),
    };
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });
    const text = "Our Mission";
    const characters = text.split("");

    return (
        <section ref={ourMissionRef} id='ourmission' className="section-appraisal style-2 tf-spacing-1 pb-5">
            <div className="wg-appraisal style-3 p-4">
                <div className="tf-container">
                    <div className="row mission-wrapper  d-flex flex-nowrap flex-column-reverse flex-md-row appraisal  ">
                        <div className="col-12 col-md-6 ">
                            <div className="heading-section">
                                <div ref={ref} className="heading-section mb-48" style={{ whiteSpace: "nowrap" }}>
                                    <h2 className="title  balance">
                                        {characters.map((char, i) => (
                                            <motion.span
                                                key={i}
                                                className="inline-block"
                                                variants={textVariants}
                                                initial="hidden"
                                                animate={inView ? "visible" : "hidden"}
                                                custom={i}
                                            >
                                                {char}
                                            </motion.span>
                                        ))}
                                    </h2>
                                </div>
                                <AnimatedContent
                                    distance={35}
                                    direction="vertical"
                                    reverse={false}
                                    config={{ tension: 80, friction: 20 }}
                                    initialOpacity={0.2}
                                    animateOpacity
                                    scale={1.1}
                                    threshold={0.2}
                                >
                                    <p className="text-1 animate__fadeInUp animate__animated">
                                        To ensure that everyone can own a piece of property without the burden of heavy loans
                                        or financial stress. We are committed to making real estate ownership accessible,
                                        affordable, and stress-free through innovative fractional ownership solutions.
                                    </p>
                                </AnimatedContent>
                            </div>
                        </div>
                        <div className="col-12 col-md-5 mission-content-img animate__fadeInRight animate__animated d-flex align-items-center">
                            <AnimatedContent
                                distance={250}
                                direction="vertical"
                                reverse={true}
                                config={{ tension: 70, friction: 30 }}
                                initialOpacity={0.3}
                                animateOpacity
                                scale={1.1}
                                threshold={0.2}
                            >
                                <div className='d-flex justify-content-center'>
                                    <img
                                        src={coOwnSpaceLogo}
                                        alt="CoOwnSpace Logo"
                                        className="img-fluid"
                                        style={{ maxWidth: '85%' }}
                                        loading="lazy"
                                    />
                                </div>

                            </AnimatedContent>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appraisal;
